export default {
  label: {
    id: 'merchant_options_payment_payout_status_information_required',
    defaultMessage:
      'To sell in this market we need you to provide specific information and documents that will be reviewed by our team.',
  },
}
